import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { heroAvatars } from '../data/avatars';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-deco-cream pt-12 pb-14 sm:pt-16 sm:pb-20 px-4 sm:px-6 lg:px-8" data-id="element-104" data-mp="4mi297ij3icw">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-105" data-mp="12a0kra1zryu3">
        <div className="flex items-center gap-3 text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-7" data-id="element-106" data-mp="xae74zi94gkr">
          <span data-id="element-107" data-mp="sa9rtct2xrw4">Crear</span>
          <span className="w-1 h-1 rounded-full bg-deco-aqua" data-id="element-108" data-mp="s9ghk1uwwk98" />
          <span data-id="element-109" data-mp="nczvdd79wfys">Regalar</span>
          <span className="w-1 h-1 rounded-full bg-deco-aqua" data-id="element-110" data-mp="nbygsyr1tbcb" />
          <span data-id="element-111" data-mp="3d1sbr0oqzpup">Vender</span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-serif text-[2rem] leading-[1.15] sm:text-5xl lg:text-[3.3rem] text-deco-forest font-semibold mb-5" data-id="element-112" data-mp="3d2tm12xxw8bd">
          Aprende la técnica de{' '}
          <span className="italic text-deco-brick" data-id="element-113" data-mp="39aupl8xknev4">Falso Vitral</span> desde
          cero con plantillas listas para imprimir
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-sm sm:text-base text-deco-forest/70 max-w-xl leading-relaxed mb-7" data-id="element-114" data-mp="3e7l59v5gs8g0">
          Convierte vidrios, frascos y espejos simples en piezas decorativas que
          puedes crear, regalar y vender. Sin experiencia previa y sin saber
          dibujar.
        </motion.p>

        <div className="inline-flex items-center gap-3 bg-white rounded-full pl-2 pr-5 py-2 border border-deco-aqua/40 shadow-sm mb-10" data-id="element-115" data-mp="2hkgj3xrw14th">
          <div className="flex -space-x-2.5" data-id="element-116" data-mp="2lmla0oqybncf">
            {heroAvatars.map(src => <img key={src} src={src} alt="" aria-hidden="true" className="w-8 h-8 rounded-full object-cover border-2 border-white" data-id="element-117" data-mp="s44h9lcvphgu" />)}
          </div>
          <div className="text-left" data-id="element-118" data-mp="de6o0r03e1ks">
            <div className="flex items-center gap-0.5" data-id="element-119" data-mp="db2c17gdy1jk">
              {[...Array(5)].map((_, i) => <Star key={i} size={12} className="text-deco-brick fill-deco-brick" data-id="element-120" data-mp="1ayt7f1vz1nby" data-mpi={i} />)}
            </div>
            <span className="block text-[11px] text-deco-forest/65 font-medium leading-tight mt-0.5" data-id="element-121" data-mp="110wpnr8j3u4v">
              +900 personas ya la están usando
            </span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[290px] aspect-[9/16] rounded-[1.75rem] overflow-hidden border-4 border-white shadow-2xl bg-deco-aqua-soft mb-10" data-id="element-122" data-mp="3lu9w2xv49s9n">
          <video src="https://cdn.magicpatterns.com/uploads/fzSvavKCYRFR5Khch7LPqU/IMG_4013.MOV" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-123" data-mp="269r2vtqphe9i" />
        </motion.div>

        <button onClick={scrollToPurchase} className="w-full sm:w-auto px-10 py-4 rounded-full bg-deco-brick text-white font-semibold text-sm sm:text-base tracking-wide shadow-lg hover:bg-deco-brick-dark transition-colors duration-200" data-id="element-124" data-mp="2kyvqjqg9sap0">
          QUIERO EMPEZAR AHORA
        </button>

        <div className="flex items-center gap-2 mt-4 text-[11px] sm:text-xs text-deco-forest/50 font-medium" data-id="element-125" data-mp="umzg9pwb9u4p">
          <ShieldCheck size={14} data-id="element-126" data-mp="zkrawrocbucl" />
          <span data-id="element-127" data-mp="zlsxntepy5a5">Acceso inmediato · Producto digital · Pago seguro</span>
        </div>
      </div>
    </section>;
}